module.exports = __webpack_public_path__ + "img/donation_title.c50895bb.png";